var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{staticClass:"text-decoration-none",attrs:{"to":_vm.route}},[_c('b-card',{staticClass:"cardSize"},[_c('img',{staticClass:"card-image rounded-circle p-2 bg-opacity-50",attrs:{"src":_vm.image}}),_c('b-card-text',{staticClass:"m-0 text-primary text-center font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.name)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }